<template>
  <div class="sendPoints">
    <img src="./tittle.png" width="100%" alt="" />
    <form id="form" method="post" onsubmit="return false" action="##">
      <div class="radio">
        <div @click="selectHandle('1')">
          <img
            v-if="select"
            src="./icon1.png"
            class="icon-select"
            width="15px"
            alt=""
          />
          <img
            v-if="!select"
            src="./icon2.png"
            class="icon-select"
            width="15px"
            alt=""
          />
          东航客户参赛
        </div>
        <div @click="selectHandle('2')">
          <img
            v-if="!select"
            src="./icon1.png"
            class="icon-select"
            width="15px"
            alt=""
          />
          <img
            v-if="select"
            src="./icon2.png"
            class="icon-select"
            width="15px"
            alt=""
          />
          盟军客户参赛
        </div>
      </div>
      <input
        type="number"
        class="clientMobile"
        placeholder="请输入手机号码"
        v-model="formData.inviteeMobile"
      />
      <input
        type="text"
        class="code"
        placeholder="请输入验证码"
        v-model="formData.code"
      />
      <button
        class="send"
        :class="{ disable: this.verifyMsg !== '获取验证码' }"
        @click="sendCode()"
      >
        {{ verifyMsg }}
      </button>
    </form>
    <div class="tips">参赛后将自动为您注册该手机号，以便后续发放积分</div>
    <div class="rule">
      <div class="rule-title">参与规则</div>
      <div class="title-box way1">方式一：首次成为东航客户</div>
      <div class="content content1">
        <div>立即开户成为东航客户并报名参赛。</div>
        <div>参赛后，初始本金大于1000元且至少有一笔交易，则视为成功参与。</div>
        <div>双方可获得2000积分奖励！</div>
      </div>
      <div class="title-box way2">方式二：已有其他公司账号</div>
      <div class="content content2">
        <div>直接报名参赛。</div>
        <div>参赛后，初始本金大于1000元且至少有一笔交易，则视为成功参与。</div>
        <div>双方可获得2000积分奖励！</div>
        <p>
          所有奖励积分将在下个交易日自动发放至邀请人手机号及报名参赛手机号。
        </p>
        <p>您可通过东航期货APP登录兑换。</p>
      </div>
    </div>

    <div class="rule introduce">
      <div class="rule-title introduce-rule">大赛简介</div>
      <div class="introduce-box introduce-box1">
        <img src="./pic1.png" alt="" />
        <div>
          “蓝海密剑”对冲基金经理公开赛，是由东航期货公司主办的模拟军事化系列品牌期货实盘赛事。
        </div>
      </div>
      <div class="introduce-box introduce-box2">
        <img src="./pic2.png" alt="" />
        <div>
          大赛的赛制完善，且具有长周期赛制、多指标账户系统评估业绩、专业增值产品服务、奖金丰富等特色。
        </div>
      </div>
      <div class="introduce-box introduce-box3">
        <img src="./pic3.png" alt="" />
        <div>
          大赛每年的奖金超过100万元，专设年度先锋勋章、晋衔奖、高地军旗手等奖项，于每届比赛结束后颁发。
        </div>
      </div>
    </div>
    <div class="tips1">
      从事证券投资或期货交易，请通过合法证券期货经营机构进行。合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询。
    </div>

    <div class="tips2">—— 投资有风险 入市需谨慎 ——</div>
    <div class="logo">
      <img src="./logo.png" alt="" />
    </div>

    <div class="submit-button">
      <div class="submit" @click="submit">立即申请</div>
    </div>
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
  </div>
</template>


<script>
/* eslint-disable */
import ajax from '@/common/ajax/ajax'
import alert from '@/components/alert/alert'
import utils from '@/Utils/utils.js'
import SERVICERECOMMANDAPI from '@/common/ajax/API/RECOMMAND.js'
export default {
  data() {
    return {
      formData: {
        inviteeMobile: '',
        type: '1',
        code: '',
        uid: ''
      },
      showAlert: false,
      alertMessage: '',
      verifyMsg: '获取验证码',
      wait: 30,
      select: true
    }
  },
  components: { alert },
  mounted() {
    const uid = utils.getUrlParam().brokerSec
    console.log(uid, 'uid')
  },
  methods: {
    sendCode() {
      if (this.verifyMsg !== '获取验证码') {
        this.alertMessage = '验证码请求太快请稍等'
        this.showAlert = true
        return
      }
      if (!utils.mobileTest(this.formData.inviteeMobile)) {
        this.alertMessage = '请输入正确的手机号码'
        this.showAlert = true
        return
      }
      let senddata = {
        mobile: $.trim(this.formData.inviteeMobile),
        type: 1003
      }

      ajax
        .sendVerifyCode(senddata)
        .then((data) => {
          let vm = this
          function time() {
            if (vm.wait === 0) {
              vm.verifyMsg = '获取验证码'
              vm.wait = 30
            } else {
              vm.verifyMsg = vm.wait + '秒后重新发送'
              vm.wait--
              setTimeout(function () {
                time()
              }, 1000)
            }
          }

          time()
          let str = data.data.resultMessage
          this.alertMessage = data.data.resultMessage
          this.showAlert = true
        })
        .catch((err) => {
          this.alertMessage = '获取验证码失败'
          this.showAlert = true
        })
    },
    async submit() {
      if (!utils.mobileTest(this.formData.inviteeMobile)) {
        this.alertMessage = '请输入正确的手机号码'
        this.showAlert = true
        return
      }
      if (!this.formData.code) {
        this.alertMessage = '验证码不能为空'
        this.showAlert = true
        return
      }
      this.formData.uid = utils.getUrlParam().brokerSec
      const res = await SERVICERECOMMANDAPI.competitionInvitation(this.formData)
      console.log(res, 'res')
      if (res.resultStatus == '0') {
        // 成功
        this.$emit('success')
      } else {
        this.alertMessage = res.resultMessage
        this.showAlert = true
      }
    },
    selectHandle(type) {
      this.formData.type = type
      this.select = type === '1' ? true : false
    }
  }
}
</script>

<style scoped>
.sendPoints {
  background: url('./bg.png') no-repeat;
  background-attachment: scroll;
  overflow: auto;
  padding: 20px 0;
}

#form {
  text-align: center;
  position: relative;
}

input {
  width: 90%;
  height: 50px;
  line-height: 50px;
  padding-left: 12px;
  color: #323232;
  font-size: 14px;
  margin-bottom: 25px;
  border: 1px solid #fff;
}

.icon-select {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  vertical-align: -3px;
}

.clientMobile {
  padding-left: 40px;
  background-image: url('3.png');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 8px 15px;
}

.code {
  padding-left: 40px;
  background-image: url('4.png');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 8px 15px;
}

.send {
  background: #f46042;
  border: #fff;
  font-size: 14px;
  color: #fff;
  width: 115px;
  height: 30px;
  line-height: 30px;
  position: absolute;
  right: 12%;
  bottom: 17%;
}

.disable {
  background: #ccc;
  border: #ccc;
}

.radio {
  display: flex;
  justify-content: space-between;
  padding: 10px 10%;
  font-size: 16px;
}

.tips {
  color: #f46042;
  font-size: 14px;
  text-align: center;
}

.rule {
  height: 550px;
  margin: 20px 20px;
  background: url('./frame1.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.rule-title {
  position: absolute;
  left: 50%;
  top: 2%;
  transform: translateX(-50%);
  font-size: 25px;
  letter-spacing: 1px;
  color: #f94807;
  font-weight: 700;
}

.title-box {
  width: 70%;
  position: absolute;
  left: 7%;
  padding: 5px;
  text-align: center;
  background-image: linear-gradient(
      181deg,
      rgba(255, 133, 0, 0.7) 0%,
      rgba(253, 70, 42, 0.7) 99%
    ),
    linear-gradient(#fa9149, #fa9149);
  border-radius: 15px;
  opacity: 0.9;
  letter-spacing: 1px;
  color: #ffffff;
}

.way1 {
  top: 13%;
}

.way2 {
  top: 43%;
}

.content {
  width: 90%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: #26070a;
}
.content1 {
  top: 23%;
}
.content2 {
  top: 52%;
}

.introduce {
  height: 450px;
}

.introduce-box {
  display: flex;
  justify-content: space-between;
  position: absolute;
  margin: 10px 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f94807;
}
.introduce-box img {
  width: 70px;
  height: 70px;
  margin-right: 10px;
}
.introduce-box div {
  flex: 1;
}

.introduce-rule {
  top: 1%;
}

.introduce-box1 {
  top: 15%;
}

.introduce-box2 {
  top: 40%;
  padding-top: 10px;
}

.introduce-box3 {
  top: 70%;
  border: none;
}

.tips1 {
  padding: 20px 5%;
  font-size: 18px;
  color: #ff4026;
}

.tips2 {
  padding: 20px;
  font-size: 18px;
  text-align: center;
  color: #ff4026;
}

.logo {
  text-align: center;
  margin-bottom: 70px;
}

.logo img {
  height: 50px;
}

.submit-button {
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0;
  background-image: linear-gradient(180deg, #ffebe5 0%, #ffb98e 100%);
}

.submit {
  width: 150px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background-color: #f46042;
  border-radius: 10px;
  margin: 15px auto 0;
}
</style>


// WEBPACK FOOTER //
// submit.vue?1458dd1e